<script setup lang="ts">
defineProps<{ images: string[] }>();
const curImage = ref(0);
</script>

<template>
  <div class="flex flex-col items-center gap-4">
    <img :src="images[curImage]" class="aspect-square w-full object-contain lg:aspect-[2/1]">
    <div class="max-w-full overflow-x-auto">
      <div class="mx-auto grid auto-cols-max grid-flow-col gap-2">
        <img v-for="(image, i) in images" :key="i" :src="image" class="aspect-square w-40 cursor-pointer object-contain hover:opacity-75 [&.active]:opacity-50" :class="{ active: curImage === i }" @click="curImage = i">
      </div>
    </div>
  </div>
</template>
